import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../../globals'
import { IFormConferenceFollowup } from "../../../../Models/Forms/IFormConferenceFollowup";
import { FormConferenceFollowupService } from "../../../../Services/FormConferenceFollowupService";
import { IepService } from "../../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../../Models/IIepInstance'
import { Message } from 'primeng/primeng';
import { ILockStatus } from '../../../../Models/ILockStatus';
import { Router } from "@angular/router";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { SpinnerBase } from '../../../Base/SpinnerBase';
import { ReportService } from 'src/app/Services/ReportService';


@Component({
  selector: 'ConferenceFollowup',
  templateUrl: './ConferenceFollowup.component.html',
  styleUrls: ['./ConferenceFollowup.component.css']

})
export class FormConferenceFollowupComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  reportParamArray: IReportParameter[];
  //public showSpinner: boolean = false;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;  
  canEditIep: boolean;
  saveClicked: boolean;
  conferenceFollowupDB: any = [];
  enclosedPlanNeedText: string = "1. The Enclosed Plan contains information regarding the lack of need/eligibility for service or ";
  enclosedPlanReviewText: string = "2. The enclosed plan is a review and continuation of present service.";
  enclosedPlanRecommendText: string = "3. The enclosed plan contains recommended services/placement not previously provided to your son/daughter.";

  constructor(
    private globals: Globals, reportService: ReportService,
    private _formConferenceFollowupService: FormConferenceFollowupService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    public router: Router) {
      super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance
  }

  ngOnInit(): void {
    this.LoadFormConferenceFollowupDetails();
    //this.LoadLookupValues();
    this.isLocked = false;
    this.canEditIep = this._myGlobals.canEdit();
    this.successMessages = [];
    this.errorMessages = [];
    this.scrollToTop();
  }

  LoadLookupValues(): void {
  }

  LoadFormConferenceFollowupDetails(): void {
    this._formConferenceFollowupService.getFormConferenceFollowup(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: IFormConferenceFollowup) => {
        this.conferenceFollowupDB = res,
        this.conferenceFollowupDB.signatureDate1 = new Date(this.conferenceFollowupDB.signatureDate1);
        this.conferenceFollowupDB.signatureDate2 = new Date(this.conferenceFollowupDB.signatureDate2);
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  //Save the conference Invitation
  save(action) {
    this.scrollToTop();
    this.clearMessages();
    this.saveClicked = true;

    //update values
    this._formConferenceFollowupService.insertUpdateFormConferenceFollowup(this.conferenceFollowupDB)
      .subscribe((res: IFormConferenceFollowup) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.loadUnLock("UnLock");
        }
        this.saveClicked = false
        this.validateForm(); 
        this.LoadFormConferenceFollowupDetails();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
        }
      )
  }

  validateForm() {
    this._formConferenceFollowupService.validateForm(this._myGlobals.selectedFormDetails.formId)
      .subscribe((res: string[]) => {
        for (var item of res) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error', detail: item };
          this.addMessage(errorMessage);
        }
      },
        err => console.error(err)
      );
  }

  loadUnLock(action) {
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=' + action)
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
      },
        err => console.error(err)
      );
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
    this._iepService.lockUnlockForm(this._baseUrl + 'api/Iep/LockUnlockForm?formInstanceId='
      + this._myGlobals.selectedFormDetails.formInstanceId + '&action=Lock')
      .subscribe((res: ILockStatus) => {
        this.isLocked = res.success
        this.lockStatus = res.status
        if (this.isLocked == true) {
          this.globals.editMode = true;
        }
        else {
          let failedMessage: Message = { severity: 'warn', summary: this.lockStatus }
          this.addMessage(failedMessage);
        }
      });
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.loadUnLock("UnLock");
    this.LoadFormConferenceFollowupDetails();
  }


  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.conferenceFollowupDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.conferenceFollowupDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: '' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'WaterMarkText', parameterValue: '' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.conferenceFollowupDB.rdlFileNameEnglish, this.reportParamArray);
  }

  printSpanish() {
    this.populateReportParameters();
    this.printFormCommon(this.conferenceFollowupDB.rdlFileNameSpanish, this.reportParamArray);
  }

}
